import React from 'react';
import { Input } from '@/components/ui/input';
import { X } from 'lucide-react';
import { DocBox, AddRowButton, DOC_FIELD } from './DocumentChrome';

/**
 * The terms, as bullets you can rewrite.
 *
 * The defaults cover nearly every job, but the one that changes — the advance,
 * the delivery window — changes per customer, so each bullet is an input and the
 * list can grow or shrink. An empty bullet is dropped on save rather than
 * printed as a stray dot.
 */
export default function TermsEditor({ heading, terms, onChange, onAdd, onRemove }) {
  return (
    <DocBox heading={heading} tone="plain">
      <ul className="space-y-0.5 p-2">
        {terms.map((term, index) => (
          <li key={index} className="flex items-start gap-1" data-testid={`term-${index}`}>
            <span className="pt-1 font-bold leading-none text-doc-gold">•</span>
            <Input
              value={term}
              onChange={(e) => onChange(index, e.target.value)}
              placeholder="Add a condition"
              aria-label={`Term ${index + 1}`}
              className={`${DOC_FIELD} text-[12px]`}
            />
            <button
              type="button"
              onClick={() => onRemove(index)}
              aria-label={`Remove term ${index + 1}`}
              data-testid={`remove-term-${index}`}
              className="mt-0.5 rounded p-0.5 text-slate-300 transition-colors hover:bg-red-50 hover:text-red-600"
            >
              <X className="h-3 w-3" />
            </button>
          </li>
        ))}
      </ul>
      <div className="px-2 pb-2">
        <AddRowButton onClick={onAdd} testId="add-term">+ Add Term</AddRowButton>
      </div>
    </DocBox>
  );
}
